import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {XpertKnowledgeTutorialGenerationType} from '../XpertKnowledgeTutorial/type'

class XpertKnowledgeGeneratorServiceProvider extends ApiService {
  async regenerate(xpertKnowledgeId: string, type: XpertKnowledgeTutorialGenerationType): Promise<void> {
    const params = new URLSearchParams()
    params.append('generation_type', type)

    const queryString = params.toString()
    return this.post<void>(`/xpert-knowledge/${xpertKnowledgeId}/generator/regenerate?${queryString}`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgeGeneratorService = new XpertKnowledgeGeneratorServiceProvider()
